import React, { useCallback, useRef } from "react";
import ReusableTable from "./ReusableTable";
import { fetchSubscribers } from "../util/fetchUserUtil";

export const OwnerTable = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchSubscribers(postData, "owners");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  const actionButtonsMeta = [
    {
      name: "Create Owner",
      action: "createOwner",
    },
  ];

  return (
    <>
      <ReusableTable
        key={"owners_table"}
        tableType={"owners"}
        tableName={"Owners"}
        needGlobalFilter={true}
        needPagination={true}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
        isExtendingReusableColumns={true}
      />
    </>
  );
};

export default OwnerTable;
